<script>
export default {
  name: "custom-header",
  props: {
    level: {
      type: Number,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  render(createElement) {
    return createElement("h" + this.level, this.text, this.$slots.default);
  }
};
</script>
